<template>
  <div class="station-item">
  <div class="station-info-content" @click="goStaDetail">
    <div class="station-title">
      <div class="station-status" v-if="item.staStatus != 50">{{item.staStatusDesc}}</div>
      {{item.staName}}
    </div>
    <div class="tag-list row-interval" v-if="item.tagList && item.tagList.length >0 ">
      <div class="tag-item" v-for="items in item.tagList" :key="items.pkId">{{items.tagName}}</div>
    </div>
    <div class="rate-info ac row-interval"  v-if="item.acGunTotalCount > 0">
      <div class="rate-flex">
        <template v-if="item.campaignPrice">
          <span class="rate-value value-active">{{item.campaignPrice.acElecFee || 0}}</span>
          <span class="rate-unit">元/度</span>
        </template>
        <template v-else-if="item.priceObj">
          <span class="rate-value value-active">{{item.priceObj.acElecFee || 0}}</span>
          <span class="rate-unit">元/度</span>
        </template>
      </div>
      <div class="pile-info">
        <div class="pile-type">交</div>
        <div class="pile-info-value">
          <span class="value-active">闲{{item.acFreeGunCount || 0}}</span> 
          <span class="">/{{item.acGunTotalCount || 0}}</span> 
        </div>
      </div>
    </div>
    <div class="rate-info dc row-interval"  v-if="item.dcGunTotalCount > 0">
      <div class="rate-flex">
        <template v-if="item.campaignPrice">
          <span class="rate-value value-active">{{item.campaignPrice.dcElecFee || 0}}</span>
          <span class="rate-unit">元/度</span>
        </template>
        <template v-else-if="item.priceObj">
          <span class="rate-value value-active">{{item.priceObj.dcElecFee || 0}}</span>
          <span class="rate-unit">元/度</span>
        </template>
      </div>
      <div class="pile-info">
        <div class="pile-type">直</div>
        <div class="pile-info-value">
          <span class="value-active">闲{{item.dcFreeGunCount || 0}}</span> 
          <span class="">/{{item.dcGunTotalCount || 0}}</span> 
        </div>
      </div>
    </div>
    <div class="station-ent row-interval"  v-if="item.currentPriceList && item.currentPriceList.length > 1">
      <img src="../../picture/index/sta-ent.png" class="station-ent-icon" />
    </div>
  </div>
  <div class="station-position row-interval">
    <div class="position-info">{{item.staAddress}}</div>
    <div class="other-info border"  @click="openLocation(item)">
      {{item.currentDistance}}km<img src="../../picture/index/distance.png" class="station-other-icon addr-icon" />
    </div>
    <div class="other-info"  @click="collected(item)">
      <template  v-if="item.ifCollected == 1">
        <img src="../../picture/index/stars.png" class="station-other-icon" />
      </template>
      <template v-else>
        <img src="../../picture/index/stars-d.png" class="station-other-icon" />
      </template>
    </div>
  </div>
</div>
</template>

<script>
import wxJsSdk from "@/common/location";
import {
  collectStation,
} from "@/common/api";
export default {
  name: "pi-station-item",
  props: {
    item: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      collection: true,
    };
  },
  methods: {
    openLocation(item) {
      var data = {
        latitude: item.staLat,
        longitude: item.staLng,
        name: item.staName,
        address: item.staAddress,
      };
      wxJsSdk.openLocation(data);
    },
    async collected(item){
      let ret = await collectStation({
        staPkId: item.staPkId,
        status: item.ifCollected == 0 ? true : false,
      },{loading:false})
      if (ret.status === 0) {
        let text = item.ifCollected == 0 ? '收藏成功': '取消成功';
        this.$toast(text,'none');
        item.ifCollected = item.ifCollected == 0 ? 1 : 0;
        item.index = this.index;
        this.$emit('change',item)
      }
    },
    goStaDetail() {
      let item = this.item;
      if(!item.staStatus || item.staStatus == 50 ){
        this.$router.push({
          name: "station-detail",
          query: { staPkId: item.staPkId },
        });
      }
    },
    
  },

};
</script>

<style lang="less" scoped>
.station-item{
  background: #FFFFFF;
  box-shadow: 0px 0px 0.10rem 0px #EFEFF4;
  border-radius: 0.16rem;
  font-size: 0.20rem;
  line-height: 0.28rem;
  overflow: hidden;
  color: #999999;
}
.station-info-content{
  padding: 0.20rem 0.20rem 0 0.20rem;
}
.station-title{
  font-size: 0.32rem;
  line-height: 0.45rem;
  color: #000;
}
.row-interval{
  margin-top: 0.10rem;
}

.tag-list{
  display: flex;
}
.tag-list .tag-item{
  padding: 0 0.10rem;
  position: relative;
}
.tag-list .tag-item::after{
  content: '';
  width: 0.01rem;
  height: 0.20rem;
  background-color: #999;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.tag-list .tag-item:first-child{
  padding-left: 0;
}
.tag-list .tag-item:first-child::after{
  background-color: #fff;
}

.rate-info{
  display: flex;
}
.rate-info .rate-flex{
  flex: 1;
}
.rate-info .rate-flex .rate-value{
  font-size: 0.50rem;
  line-height: 0.50rem;
}

.rate-info .pile-info {
  width:1.5rem;
  font-size: 0.24rem;
  line-height: 0.33rem;
  display: flex;
  justify-items: center;
  align-items: center;
}
.rate-info .pile-info .pile-type{
  width: 0.30rem;
  height: 0.30rem;
  line-height: 0.30rem;
  display: inline-block;
  border-radius: 0.04rem;
  color: #fff;
  text-align: center;
}
.pile-info-value{
  font-size: 0.24rem;
  line-height: 0.33rem;
  display: inline-block;
  margin-left: 0.05rem;
}
.rate-info.ac .pile-info .pile-type{
  background: linear-gradient(141deg, #03F0B2 0%, #14CC80 100%);
}
.rate-info.dc .pile-info .pile-type{
  background: linear-gradient(137deg, #FAD961 0%, #FFA244 100%, #FFA244 100%);
}
.rate-info.ac .value-active{
  color: #14CC80;
}
.rate-info.dc .value-active{
  color: #FFA244;
}

.station-ent .station-ent-icon{
  width: 1.36rem;
  height: 0.34rem;
  vertical-align: top;
}

.station-position{
  display: flex;
  padding: 0 0.20rem;
  background-color: #FAFAFA;
}
.station-position .position-info{
  flex: 1;
  padding:0.10rem 0.10rem 0.10rem 0;
}
.station-position .other-info{
  padding-left: 0.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.station-position .other-info .station-other-icon.addr-icon{
  margin-right: 0.1rem;
  margin-left: 0.05rem;
}
.station-position .other-info .station-other-icon{
  width: 0.34rem;
  height: 0.34rem;
 
} 
.station-position .other-info.border{
  position: relative;
}
.station-position .other-info.border::after{
  content: '';
  position: absolute;
  width: 0.01rem;
  height: 0.20rem;
  background-color: #999;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.station-status{
  background: rgba(230,67,64,0.1);
  border-radius: 0.22rem;
  display: inline-block;
  vertical-align: top;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.2rem;
  padding: 0 0.1rem;
  color: #E64340;
}
</style>
